<template>
  <div class="mb-2 sub-menu">
    <b-button
      :id="menu.routeName"
      :variant="
        $route.meta.navActiveTab == menu.active ? `primary` : `outline-primary`
      "
      v-for="menu in menus"
      :key="`menu-${menu.routeName}`"
      class="mr-1"
      @click="
        $router.push({ name: menu.routeName, params: { id: $route.params.id } })
      "
    >
      {{ $t(menu.label) }}
    </b-button>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";

export default {
  components: {
    BButton,
  },
  data() {
    return {
      menus: [
        {
          routeName: "update-company",
          active: "update-company",
          label: "breadcrumb.updateCompany",
        },
        {
          routeName: "list-company-block-number",
          active: "company-block-number",
          label: "breadcrumb.blockNumber",
        },
        {
          routeName: "list-company-allow-number",
          active: "company-allow-number",
          label: "breadcrumb.allowNumber",
        },
        {
          routeName: "list-company-sell-out",
          active: "company-sell-out",
          label: "breadcrumb.sellOut",
        },
        {
          routeName: "list-company-bet-setting",
          active: "company-bet-setting",
          label: "breadcrumb.betSetting",
        },
      ],
    };
  },
  mounted() {
    this.scrollToMenu();
  },
  methods: {
    scrollToMenu() {
      setTimeout(() => {
        const element = document.getElementById(this.$route.name);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
        }
      }, 200);
    },
  },
  setup() {},
};
</script>